export default "__VITE_ASSET__0b45b2fb__"